import { useCallback } from 'react';
import { useClientNavigationPushState } from '@alltrails/core/hooks/useClientNavigation';
import { advancedBuilderPath } from '../utils/customRouteBuilderPaths';

// The advanced builder is its own root layout, which a shallow push can't render, so a URL into it gets a full page load
const useCustomRouteBuilderPushState = () => {
  const pushState = useClientNavigationPushState();

  return useCallback(
    (url: string) => {
      if (url.includes(advancedBuilderPath)) {
        window.location.assign(url);
      } else {
        pushState(url);
      }
    },
    [pushState]
  );
};

export default useCustomRouteBuilderPushState;
